import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import * as AmdocsContentConstants from '../../../content.constants';

@Component({
  selector: 'app-lottery-popup',
  templateUrl: './lottery-popup.component.html',
  styleUrls: ['./lottery-popup.component.scss']
})
export class LotteryPopupComponent  {

  public amdocsContentConstant: any = AmdocsContentConstants?.default;

  @Output() onCloseCallback: EventEmitter<any> = new EventEmitter();

  close(): void {
    this.onCloseCallback.emit();
  }
}
